import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../../commonFunctions";
  const ms250 = {
    label: "Crop Rate",
    pageLabel: "Crop Rate",
    starting: true,
    url: "croprate",
    pageType: "history",
    formTabs: {
        allTabs: [
          { label: "Filter Option", uid: "filteroption", style: { fontFamily: "verdana" } },
           
        ]
      },
    form: [
        {
            inputType: "displaytext",
            tab: "filteroption",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Season",
            name: "",
            description: "Enter Season"
          },
          {
            inputType: "text",
            tab: "filteroption",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Season",
            name: "Season",
            description: "Enter Season"
          },
          {
            inputType: "displaytext",
            tab: "filteroption",
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "Enter Season"
          },
          {
            inputType: "displaytext",
            tab: "filteroption",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Hangam",
            name: "",
            description: "Enter Hangam"
          },
          {
            inputType: "text",
            tab: "filteroption",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Hangam",
            name: "Hangam",
            description: "Enter Hangam"
          },
          {
            inputType: "displaytext",
            tab: "filteroption",
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "Enter Season"
          },
          {
            inputType: "displaytext",
            tab: "filteroption",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Crop",
            name: "",
            description: "Enter Crop"
          },
          {
            inputType: "text",
            tab: "filteroption",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Crop",
            name: "Crop",
            description: "Enter Crop"
          },
          {
            inputType: "displaytext",
            tab: "filteroption",
            widths: {
              parent: "col-sm-8",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "",
            name: "",
            description: "Enter Season"
          },
          {
            inputType: "displaytext",
            tab: "filteroption",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Land Type",
            name: "",
            description: "Enter Land Type"
          },
          {
            inputType: "text",
            tab: "filteroption",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "Land Type",
            name: "Land_Type",
            description: "Enter Land Type"
          },
    ]
  };
  export default ms250;